function fromNow() {
  'ngInject';
  return function(datetime) {

    return moment(datetime).fromNow();

  };
}

export { fromNow };
